module.exports = __webpack_public_path__ + "static/media/pfp portfolio.251c11e9.jpeg";